import gql from 'graphql-tag';
import { ImageFields } from '../../common-fields.queries';

export const CART_DRAWER_RECS = gql`
	${ImageFields}
	query CartDrawerRecommendedProducts($familyId: Int!, $variantId: Int!, $path: String!) {
		productFamily(id: $familyId) {
			... on ProductFamily {
				cartDrawerRecommendedProducts(variantId: $variantId, path: $path) {
					groupTitle
					items {
						title
						modelNumber
						brandName
						familyId
						origin
						isConfigurable
						variants {
							id
							name
							image {
								...ImageFields
							}
							price
							url
							stock
						}
					}
				}
			}
		}
	}
`;
